export interface MetaWebhookHealthStatus {
  configuredUrl?: string | null;
  expectedUrl?: string | null;
  matches: boolean;
  hasOverride?: boolean;
  overrideUrl?: string | null;
  rawConfiguration?: Record<string, unknown> | null;
  rawConfig?: Record<string, unknown> | null;
}

export interface MetaWebhookProvisioningStatus {
  success: boolean;
  message: string;
  error?: string | null;
  needsManualRetry?: boolean;
  expectedWebhookUrl?: string | null;
  healthStatus?: MetaWebhookHealthStatus;
}

export interface MetaWabaSubscription {
  appId?: string | null;
  appName?: string | null;
  appLink?: string | null;
  overrideCallbackUri?: string | null;
}

export type WhatsAppWebhookConnectionState = 'synced' | 'not_configured' | 'needs_finish';

export type InboxWebhookHealthView =
  | { status: 'loading' }
  | { status: 'synced'; expectedUrl?: string | null; configuredUrl?: string | null }
  | { status: 'not_configured'; expectedUrl?: string | null; configuredUrl?: string | null }
  | { status: 'mismatch'; expectedUrl?: string | null; configuredUrl?: string | null }
  | { status: 'error'; message: string };

export function classifyWhatsAppWebhookHealth(data: MetaWebhookHealthStatus): WhatsAppWebhookConnectionState {
  if (data.matches)
  {
    return 'synced';
  }

  if (!data.configuredUrl && !data.hasOverride)
  {
    return 'not_configured';
  }

  return 'needs_finish';
}

export function inboxWebhookHealthFromStatus(data: MetaWebhookHealthStatus): InboxWebhookHealthView {
  const connection = classifyWhatsAppWebhookHealth(data);
  if (connection === 'synced')
  {
    return {
      status: 'synced',
      expectedUrl: data.expectedUrl,
      configuredUrl: data.configuredUrl,
    };
  }

  if (connection === 'not_configured')
  {
    return {
      status: 'not_configured',
      expectedUrl: data.expectedUrl,
      configuredUrl: data.configuredUrl,
    };
  }

  return {
    status: 'mismatch',
    expectedUrl: data.expectedUrl,
    configuredUrl: data.configuredUrl,
  };
}
